import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    timeout: 15000,
});

export const fetchKatlasStatus = () => api.get("/katlas/status").then((r) => r.data);
export const fetchCurrentRoute = () => api.get("/prompt/route/current").then((r) => r.data);
export const fetchPatterns = () => api.get("/patterns").then((r) => r.data.patterns);
export const fetchAvoidExamples = () =>
    api.get("/avoid-llm-examples").then((r) => r.data.examples);

export const approveRoute = (body = {}) => api.post("/prompt/route/approve", body).then((r) => r.data);
export const refuseRoute = (body = {}) => api.post("/prompt/route/refuse", body).then((r) => r.data);
export const reusePattern = (body = {}) =>
    api.post("/prompt/route/reuse-pattern", body).then((r) => r.data);

export const fetchPublicReceipt = (hash) =>
    api.get(`/prompt/receipts/${encodeURIComponent(hash)}/public`).then((r) => r.data);
